import throttle from 'lodash.throttle';
import { Ref, RefObject, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { VariableSizeList } from 'react-window';
import useResizeObserver from 'use-resize-observer/polyfilled';

export const useWindowResizer = (): [Ref<HTMLDivElement>, number] => {
    const [size, setSize] = useState({ width: window.innerWidth });

    const throttledCalculateSize = useMemo(() => throttle(setSize, 200), []);

    const { ref } = useResizeObserver<HTMLDivElement>({
        onResize: throttledCalculateSize,
    });

    return [ref, size.width];
};

// Для VirtualList нужна высота, внутри которой элементы будут рендериться.
// Не на пабликах должен скролиться window, поэтому подписываемся на скролл и самостоятельно проскраливаем VirtualList
type TScrollerReturnType = [RefObject<VariableSizeList>, RefObject<HTMLDivElement>];
export const useWindowScroller = (customScrollElement?: HTMLDivElement | null): TScrollerReturnType => {
    const ref = useRef<VariableSizeList>(null);
    const outerRef = useRef<HTMLDivElement>(null);
    const scrollElement = customScrollElement || window;

    const handleScroll = useCallback((): void => {
        const offsetTop = outerRef.current?.getBoundingClientRect().top || 0;
        const scrollTop = customScrollElement ? customScrollElement.scrollTop : -offsetTop;
        ref.current?.scrollTo(scrollTop);
    }, [customScrollElement]);

    const throttledHandleScroll = throttle(handleScroll, 100);

    useEffect(() => {
        scrollElement.addEventListener('scroll', throttledHandleScroll);

        return (): void => scrollElement.removeEventListener('scroll', throttledHandleScroll);
    }, [throttledHandleScroll, scrollElement]);

    return [ref, outerRef];
};
